/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { useMemo } from "react";
import { Checkbox, Flex } from "../../..";
import { useOptionListValue, useOptionListValues } from "../../OptionList.provider";
import { optionItemCheckboxCSS } from "../OptionItem.css";
import type { OptionItemCheckBoxProps } from "../OptionItem.types";

export const OptionItemCheckboxCore = ({
  suffix,
  onClickSuffix,
  disabled,
  value,
  label,
  text,
  ...restCheckboxProps
}: OptionItemCheckBoxProps) => {
  const contextValue = useOptionListValue();
  const contextValues = useOptionListValues();
  const deprecatedLabel = label || text;

  const isChecked = useMemo(() => {
    const textValue = value || deprecatedLabel;

    if (contextValues && textValue) {
      return contextValues.includes(textValue);
    }

    return contextValue === textValue;
  }, [contextValue, contextValues, deprecatedLabel, value]);

  return (
    <Flex justifyContent="space-between" alignItems="center" css={optionItemCheckboxCSS}>
      <Checkbox.Label
        sx={{
          flex: 1,
          label: {
            cursor: "pointer",
          },
        }}
        label={deprecatedLabel}
      >
        <Checkbox checked={isChecked} disabled={disabled} {...restCheckboxProps} />
      </Checkbox.Label>

      {suffix && (
        <div
          aria-hidden
          css={[
            vars.semantic.typography["label-small"],
            {
              color: vars.semantic.color[disabled ? "textDisabled" : "textSub"],
            },
          ]}
          onClick={(event) => {
            event.stopPropagation();
            onClickSuffix?.();
          }}
        >
          {suffix}
        </div>
      )}
    </Flex>
  );
};
